import { type FC } from "react"

import type { RecordType, TableStatColumn, TableStatRow } from "types/dashboard.types"

import LabelCell from "./LabelCell"
import ValueCell from "./ValueCell"
import TimestampCell from "./TimestampCell"
import PercentageBarCell from "./PercentageBarCell"

interface TableStatCellProps {
  column: TableStatColumn
  row: TableStatRow
  records: RecordType[]
  suffix: string
  decimalPlaces: number
  threshold?: number
  seasonalThreshold?: Record<string, number>
  locale: string
}

const TableStatCell: FC<TableStatCellProps> = ({
  column,
  row,
  records,
  suffix,
  decimalPlaces,
  threshold,
  seasonalThreshold,
  locale,
}) => {
  const lastRecord = records[records.length - 1]

  switch (column.type) {
    case "label":
      return <LabelCell column={column} row={row} />

    case "value":
      return (
        <ValueCell
          column={column}
          value={lastRecord?._value}
          suffix={suffix}
          decimalPlaces={decimalPlaces}
          locale={locale}
        />
      )

    case "timestamp":
      return (
        <TimestampCell column={column} time={lastRecord?._time as string | undefined} />
      )

    case "percentageBar":
      return (
        <PercentageBarCell
          records={records}
          threshold={threshold}
          seasonalThreshold={seasonalThreshold}
          locale={locale}
        />
      )

    default:
      return null
  }
}

export default TableStatCell
